<template>
    <div class="month-card plan-month-card">
        <div class="lunar-calendar">
            <div class="gl clearfix">
			<span class="gl-month">
                <span class="month" v-bind:class="{'current': currentMonth}">{{ data.month }} <span
                        style="font-size: 14px;">月</span></span>
                   <span class="current-month" v-bind:style="{ display: activeStatus}">（本月）</span>
			</span>
                <span class="gl-year">{{ data.year }}</span>
            </div>
        </div>
        <div class="card-plan-wrap">
            <div class="month-plan plan-detail" style="position: relative;">
                <div v-if="monthPlan==null" class="line-height-28 font14">月计划:<span class="color999"
                                                                                    style="font-size: 12px;">未制定</span>
                </div>
                <h5 v-if="monthPlan!=null" class="ellipsis calendar-limit-title month-plan-title"
                    v-bind:title="monthPlan.title">
                    <router-link :to="{ name: 'planinfo' , params: { id:monthPlan.id} }">
                        {{ monthPlan.title }}
                    </router-link>
                    <span v-if="monthPlan.rate_of_progress > 0"
                          style="position: absolute;right: 3%;float: right;">{{
                            Math.floor(monthPlan.rate_of_progress * 100) / 100
                        }}%</span>
                    <span v-else style="position: absolute;right: 3%;float: right;">未开始</span>
                </h5>
                <router-link v-if="monthPlan==null" :to="{ name: 'newplan' , params: { planType: 'month',dateValue:data.year+'-'+data.month ,startDate:data.year+'-'+data.month+'-01'} }"
                             class="click-new-create">
                    <span>点击新建</span></router-link>
            </div>
            <div class="week-plan">
                <ul v-for="(week,index) in getWeeksWithYearAndMonth"
                    :key="index">
                    <li class="single-week-wrap  plan-detail" v-bind:class="{currentweek:week.isCurrent}">
                        <div class="single-week" style="position: relative;">
                            <div v-if="week.plan==null" class="has-not-plan">
                                <div class="week-num-title calendar-limit-title">
                                     <p  v-if="week.isCurrent" style="font-weight: bold;margin: 0">  {{week.summary}}</p>
                                     <p  v-else style="margin: 0">  {{week.summary}}</p>
                                    <h5 class="week-title ellipsis color999">未制定</h5>
                                    <router-link class="click-new-create"
                                    :to="{ name: 'newplan' , params: { planType: 'week',dateValue:week.start,startDate:week.start,endDate:week.end} }">
                                        点击新建
                                    </router-link>
                                </div>
                            </div>
                            <div v-if="week.plan!=null" class="has-plan">
                                <div class="week-num-title calendar-limit-title">
                                    <p  v-if="week.isCurrent" style="font-weight: bold;margin: 0">  {{week.summary}}</p>
                                     <p  v-else style="margin: 0">  {{week.summary}}</p>
                                    <span  :class="rateClass(week.plan.rate_of_progress)"
                                          style="position: absolute;right: 3%;float: right;font-weight: bold;top: 0;" title="计划进度">{{
                                            Math.floor(week.plan.rate_of_progress * 100) / 100
                                        }}%</span>

                                    <h5 class="week-title ellipsis" v-bind:title="week.plan.title">
                                        <router-link :to="{ name: 'planinfo' , params: { id:week.plan.id} }">
                                            {{ week.plan.title }}
                                        </router-link>
                                    </h5>
                                </div>

                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="custom-plan-group plan-detail" style="position: relative;">
                <div v-if="getCustomsPlans!=null" class="line-height-28 font14">自定义计划<span
                        class="num-icon">{{ getCustomsPlans.filter(x => x.is_date_area).length }}</span></div>
            </div>
            <div class="custom-plan">
                <ul v-for="(custom,index) in getCustomsPlans" :key="index">
                    <li class="single-custom-wrap  plan-detail">
                        <div class="single-custom" style="position: relative;">
                            <div v-if="custom.is_date_area" class="has-plan">
                                <div class="week-num-title calendar-limit-title">
                                    <h5 class="ellipsis" v-bind:title="custom.plan_info.title" style="font: inherit;">
                                        <router-link :to="{ name: 'planinfo' , params: { id:custom.plan_info.id} }">
                                            {{ custom.plan_info.title }}
                                        </router-link>
                                        <span  :class="rateClass(custom.plan_info.rate_of_progress)"
                                              style="position: absolute;right: 3%;float: right;font-weight: bold;">{{
                                                Math.floor(custom.plan_info.rate_of_progress * 100) / 100
                                            }}%</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
    props: {
        data: {
            type: Object,
            selectYear: '',
            require: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState({
            my_plans: state => state.plan.my_plans,
        }),
        ...mapGetters({
            display_plans: 'plan/display_plans',
        }),
        monthPlan: function () {
            let p = []
            for (var i = 0; i < this.my_plans.length; i++) {
                if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.data.year && (new Date(this.my_plans[i].open_time)).getMonth() == (this.data.month - 1)) {
                    p.push(this.my_plans[i])
                    break
                }
            }
            return p.length > 0 ? p[0] : null
        },
        currentMonth: function () {
            return (((new Date()).getMonth() + 1) == this.data.month && (new Date()).getFullYear() == this.data.year) ? true : false;
        },
        activeStatus: function () {
            return (((new Date()).getMonth() + 1) == this.data.month && (new Date()).getFullYear() == this.data.year) ? "" : "none";
        },
        getCustomsPlans() {
            const curr_date_start = new Date(this.data.year + '-' + this.data.month + '-1');
            const curr_date_end = new Date(this.data.year + '-' + this.data.month + '-' + new Date(this.data.year, this.data.month, 0).getDate());
            let customPlans = [];
            for (let i = 0; i < this.my_plans.length; i++) {
                const open_date = new Date(this.my_plans[i].open_time);
                const end_date = new Date(this.my_plans[i].end_time);

                if (this.my_plans[i].plan_type === "custom") {
                    let custom_plan = new Object();
                    custom_plan.is_date_area = false;
                    if (curr_date_end >= open_date && curr_date_start <= end_date) {
                        custom_plan.is_date_area = true;
                        custom_plan.plan_info = this.my_plans[i];
                    }
                    customPlans.push(custom_plan);
                }
            }
            return customPlans;
        },
        getWeeksWithYearAndMonth() {
            let month = this.data.month;
            let years = this.data.year;
            let weeks = [];//现将星期数组重制一次
            let month2 = parseInt(month) - 1;
            let myDate = new Date(years, month2, 1);//获取每个月的第一天是星期几
            let firstDay = myDate.getDay();
            let myDate2 = new Date(years, month, 0);
            let days = myDate2.getDate();//获取每个月有多少天
            let firstMonday = '';
            let lastDay = '';
            let dataNow = new Date()
            //if(firstDay==0)firstDay=7;
            if (firstDay - 1 == 0) {
                firstMonday = firstDay;
                lastDay = days;
            } else {
                firstMonday = 7 - firstDay + 2;
                lastDay = days - (7 - firstDay + 1);
            }

            let weeksCount = Math.floor(lastDay / 7);
            let startIdx = 0;
            if (firstDay - 1 != 0) {
                let week = new Object();
                let startWeek = this.addDays(years + '/' + month + '/' + 1, -(7 - firstMonday + 1))
                week.start = startWeek.getFullYear() + '/' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate();
                week.end = years + '/' + month + '/' + (firstMonday - 1);
                week.summary = '第' + this.getWeek(years + '/' + month + '/' + 1) + '周' + ' (' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate() + '-' + month + '/' + (firstMonday - 1) + ')';
                week.value = 1;
                week.plan = this.weekPlan(new Date(week.start));
                week.isCurrent = false
                if (dataNow >= (new Date(week.start)) && dataNow <= (new Date(week.end))){
                    week.isCurrent = true
                    week.summary = '本周' + ' (' + (startWeek.getMonth() + 1) + '/' + startWeek.getDate() + '-' + month + '/' + (firstMonday - 1) + ')';
                }
                weeks.push(week);
                startIdx = 1;
            }

            let weekth = '';
            for (let i = 0; i < weeksCount; i++) {
                weekth = i + 1 + startIdx
                let week = new Object();
                week.start = years + '/' + month + '/' + (firstMonday + 7 * i);
                week.end = years + '/' + month + '/' + ((firstMonday + 7 * i) + 7 - 1);
                week.summary = '第' + this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * i)) + '周 (' + month + '/' + (firstMonday + 7 * i) + '-' + month + '/' + ((firstMonday + 7 * i) + 7 - 1) + ')';
                week.value = (i + 1 + startIdx).toString();
                week.plan = this.weekPlan(new Date(week.start));
                week.isCurrent = false
                if (dataNow >= (new Date(week.start)) && dataNow <= (new Date(week.end))){
                      week.isCurrent = true
                      week.summary = '本周 (' + month + '/' + (firstMonday + 7 * i) + '-' + month + '/' + ((firstMonday + 7 * i) + 7 - 1) + ')';
                }
                weeks.push(week);
            }
            let shengyuDays = lastDay % 7;
            if (shengyuDays > 0) {
                let endWeek = this.addDays(years + '/' + month + '/' + ((firstMonday + 7 * weeksCount) + shengyuDays - 1), (7 - shengyuDays))
                let week = new Object();
                week.label = month + '/' + (firstMonday + 7 * weeksCount) + '-' + month + '/' + ((firstMonday + 7 * weeksCount) + shengyuDays - 1);
                week.start = years + '/' + month + '/' + (firstMonday + 7 * weeksCount);
                week.end = endWeek.getFullYear() + '/' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate();
                week.summary = '第' + this.getWeek(years + '/' + month + '/' + (firstMonday + 7 * weeksCount)) + '周' + ' (' + month + '/' + (firstMonday + 7 * weeksCount) + '-' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate() + ')';
                week.value = (weekth + 1).toString();
                week.plan = this.weekPlan(new Date(week.start));
                week.isCurrent = false
                if (dataNow >= (new Date(week.start)) && dataNow <= (new Date(week.end))){
                     week.isCurrent = true
                      week.summary = '本周' + ' (' + month + '/' + (firstMonday + 7 * weeksCount) + '-' + (endWeek.getMonth() + 1) + '/' + endWeek.getDate() + ')';

                }
                weeks.push(week);
            }
            return weeks;
        }
    },
    methods: {
        ...mapActions({}),
                rateClass: function(rate){
           if(rate==0) return 'undoRate';
            if(rate==100) return 'finishRate';
            else return 'ondoRate';
        },
        addDays(theDateStr, days) {
            let d = new Date(theDateStr)
            d.setMilliseconds(d.getMilliseconds() + (days * 24 * 60 * 60 * 1000));
            return d;
        },
        weekPlan: function (start) {
            let p = []
            for (var i = 0; i < this.my_plans.length; i++) {
                if (this.my_plans[i].plan_type === "week" && (new Date(this.my_plans[i].open_time)).getFullYear() == start.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() == start.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() == start.getDate()) {
                    p.push(this.my_plans[i])
                    break
                }
            }
            return p.length > 0 ? p[0] : null
        },
        getWeek: function (z) {//参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
            let day11 = new Date(z);
            day11.setMonth(0);
            day11.setDate(1);
            day11.setHours(0);
            day11.setMinutes(0);
            day11.setSeconds(0);//到这里就得到该年的一月一日

            let day11mill = day11.getTime();
            let ori_day = day11.getDay();//该年的一月一日是星期几
            let fill1 = 0;//与星期日相隔的毫秒数
            if (ori_day !== 0) {
                fill1 = ori_day * 60 * 60 * 24 * 1000;
            }

            let now = Date.parse(z);
            now = new Date(now);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            let nowmill = now.getTime();
            let now_day = now.getDay();
            let fill2 = 0;
            if (now_day !== 0) {
                fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
            }

            let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
            let week = Math.ceil(cha2 / 7);
            if (week < 10) {
                week = "0" + week;
            }
            return week;
        }
    },
    mounted() {

    }
}
</script>

<style scoped type="text/css">
    .undoRate{
        color: red;
    }
    .finishRate{
        color: #0b2e13;
    }
        .ondoRate{
        color: #004488;
    }
.month-card {
    float: left;
    position: relative;
    margin-right: 40px;
    width: 270px;
    background-color: #fff;
    box-shadow: 0 5px 5px 0px #d9d9d9;
    overflow: hidden;
    min-height: 500px;
    margin-bottom: 10px;
}

.month-card .lunar-calendar {
    padding: 5px 10px 5px;
    color: #fff;
    border-bottom: 1px solid #dedede;
    border-top: 1px solid #dedede;
}

.month-card .lunar-calendar .gl-month {
    float: left;
    font-size: 30px;
    color: #666;
}

.month-card .lunar-calendar .gl-year {
    float: right;
    font-size: 18px;
    color: #999;
    margin-top: 5px;
}

.month-card .card-plan-wrap .month-plan {
    height: 45px;
    margin-left: 5.52%;
    border-bottom: 1px solid #ededed;
}

.month-card .card-plan-wrap .custom-plan-group {
    height: 45px;
    margin-left: 5.52%;
    border-bottom: 1px solid #ededed;
}

.month-card .month-plan-title {
    margin: 0;
    font-size: 14px;
    color: #333;
    line-height: 24px;
    font-weight: normal;
    font-weight: bold;
}


.month-card .month-plan .month-ver-time {
    line-height: 20px;
}

.month-card .custom-plan-group .custom-ver-time {
    line-height: 20px;
}

.month-card .last-modify {
    float: right;
    color: #999999;
    margin-right: 6.25%;
}

.month-card a.click-look.has-time {
    top: 30%;
}

.month-card .card-plan-wrap .week-plan {
    width: 100%;
}

.month-card .card-plan-wrap .custom-plan {
    width: 100%;
}

.single-week-wrap {
    margin-top: -1px;
}

.single-custom-wrap {
    margin-top: -1px;
}

.plan-container .month-card .week-plan .single-week-wrap {
    position: relative;
    padding: 0;
}

.plan-container .month-card .custom-plan .single-custom-wrap {
    position: relative;
    padding: 0;
}

.month-card .card-plan-wrap .week-plan ul .single-week-wrap {
    margin-left: -1px;
    margin-right: -1px;
    cursor: pointer;
    display: block;
}

.month-card .card-plan-wrap .custom-plan ul .single-custom-wrap {
    margin-left: -1px;
    margin-right: -1px;
    cursor: pointer;
    display: block;
}

.single-week {
    margin-left: 7%;
    border-bottom: 1px solid #ededed;
}

.single-custom {
    margin-left: 7%;
    border-bottom: 1px solid #ededed;
}

.week-plan ul .has-plan {
    height:65px;
    line-height: 64px;
}

.custom-plan {
    height: 110px;
    overflow-y: auto;
    overflow-x: hidden;
}

.custom-plan ul .has-plan {
    height: 35px;
    padding-top: 5px;
}

.num-icon {
    width: 16px;
    height: 16px;
    padding: 0 4px;
    margin: 0 5px;
    border-radius: 8px;
    line-height: 16px;
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    background-color: #00a4ff;
}

.month-card .has-not-plan {
    height:65px;
    font-size: 12px;
    line-height: 64px;
    width: 100%;
}

.gl-month .current-month {
    color: #999;
    font-size: 14px;
    vertical-align: 1px;
}

.gl-month .month.current {
    color: #222;
    font-weight: bold;
}

.month-card.current .gl-month .month {
    color: #222;
    font-weight: bold;
}

.gl-month .current-month {
    color: #999;
    font-size: 14px;
    vertical-align: 1px;
}

.font14 {
    font-size: 14px;
}

.line-height-28 {
    line-height: 28px;
}

.color999 {
    color: #999 !important;
}

.has-not-plan span {
    color: #999;
}

a.click-new-create {
    display: none;
    position: absolute;
    right: 6.25%;
    color: #29e;
    font-size: 12px;
    margin-top: -6px;
    line-height: 12px;
    top: 50%;
}

.month-card .month-plan {
    padding: 10px 0;
}

.month-card .custom-plan-group {
    padding: 10px 0;
}

.month-plan:hover > a.click-new-create {
    display: inline-block;
}

.has-not-plan:hover > a.click-new-create {
    display: inline-block;
}

.week-num-title:hover > a.click-new-create {
    display: inline-block;
}

.week-num-title {
    line-height: 26px;
}

.week-title {
    margin-left: 10px;
    font: inherit;
    font-size: 13px;
}

.calendar-limit-title {
    width: 100%;
    font-size: 12px;
    white-space: nowrap;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ellipsis {
    white-space: nowrap;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
}

.week-plan ul .currentweek.single-week-wrap {
    background-color: #fffccc;
}
</style>
